import React from "react"
import styled from "styled-components"
import Theme from "@styles/theme"
import PropTypes from "prop-types"
import Div from "./div"

// Can make font size take "size" variable that runs it through the theme
// If we do that, should also take "fontSize" and override if exists
// TODO
const StyledQuote = styled(Div)``

StyledQuote.defaultProps = {
  as: "blockquote",
  background: Theme.color.blueLight,
  center: true,
  fontSize: Theme.defaults.fontSize.p,
  color: Theme.color.blue400,
  lineHeight: "200%",
  padding: "4rem",
  mobileScale: 0.9,
  margin: "0 !important",
  width: "100%",
}

const Quote = ({ children, ...rest }) => {
  return <StyledQuote {...rest}>{children}</StyledQuote>
}

Quote.propTypes = {
  children: PropTypes.node,
}

export default Quote
